import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormGroup,
  FormControl,
  FormBuilder,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDatepickerMaskDirective } from '@anihis/shared/src/shared/directive/mat-datepicker-mask.directive';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslocoModule } from '@jsverse/transloco';
import { appInit } from '@anihis/shared/src/functions/appInitLang';
import {
  getMaxBirthDate,
  getMinAnimalBirthDate,
} from '@anihis/shared/src/validators/birth-date.validators';

@Component({
  selector: 'anihis-rabies-examination-certificate',
  templateUrl: './rabies-examination-certificate.component.html',
  styleUrls: ['./rabies-examination-certificate.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDatepickerMaskDirective,
    MatNativeDateModule,
    TranslocoModule,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useFactory: appInit }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RabiesExaminationCertificateComponent {
  minDate = getMinAnimalBirthDate();
  today = getMaxBirthDate();

  @Output() formChange = new EventEmitter<any>();

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      injuriesDetails: new FormControl(''),
      exam1Date: new FormControl(null),
      exam1Findings: new FormControl(''),
      exam1Veterinarian: new FormControl(''),
      exam2Date: new FormControl(null),
      exam2Findings: new FormControl(''),
      exam2Veterinarian: new FormControl(''),
      exam3Date: new FormControl(null),
      exam3Findings: new FormControl(''),
      exam3Veterinarian: new FormControl(''),
      notes: new FormControl(''),
      veterinarianName: new FormControl(''),
    });

    this.form.valueChanges.subscribe((value) => this.formChange.emit(value));
  }

  get injuriesDetails(): FormControl {
    return this.form.get('injuriesDetails') as FormControl;
  }

  get exam1Date(): FormControl {
    return this.form.get('exam1Date') as FormControl;
  }

  get exam1Findings(): FormControl {
    return this.form.get('exam1Findings') as FormControl;
  }

  get exam1Veterinarian(): FormControl {
    return this.form.get('exam1Veterinarian') as FormControl;
  }

  get exam2Date(): FormControl {
    return this.form.get('exam2Date') as FormControl;
  }

  get exam2Findings(): FormControl {
    return this.form.get('exam2Findings') as FormControl;
  }

  get exam2Veterinarian(): FormControl {
    return this.form.get('exam2Veterinarian') as FormControl;
  }

  get exam3Date(): FormControl {
    return this.form.get('exam3Date') as FormControl;
  }

  get exam3Findings(): FormControl {
    return this.form.get('exam3Findings') as FormControl;
  }

  get exam3Veterinarian(): FormControl {
    return this.form.get('exam3Veterinarian') as FormControl;
  }

  get notes(): FormControl {
    return this.form.get('notes') as FormControl;
  }

  get veterinarianName(): FormControl {
    return this.form.get('veterinarianName') as FormControl;
  }

  clearForm() {
    this.form.reset();
  }
}
